import { combineReducers } from 'redux';

import adminReducer from './AdminReducer';
import anakPerusahaanReducer from './AnakPerusahaanReducer';
import appReducer from './AppReducer';
import asetInvestasiReducer from './AsetInvestasiReducer';
import csrReducer from './CSRReducer';
import eMagazineReducer from './EMagazineReducer';
import GCGReducer from './GCGReducer';
import globalReducer from './GlobalReducer';
import heroReducer from './HeroReducer';
import hotelReducer from './HotelReducer';
import inquiryReducer from './InquiryReducer';
import karirReducer from './KarirReducer';
import KomiteGCGReducer from './KomiteGCGReducer';
import kotaReducer from './KotaReducer';
import laporanKeuanganReducer from './LaporanKeuanganReducer';
import laporanTahunanReducer from './LaporanTahunanReducer';
import LayoutReducer from './LayoutReducer';
import LoginReducer from './LoginReducer';
import manajemenPerusahaanReducer from './ManajemenPerusahaanReducer';
import mediaReducer from './MediaReducer';
import milestoneReducer from './MilestoneReducer';
import mitraReducer from './MitraReducer';
import NavigationReducer from './NavigationReducer';
import portfolioReducer from './PortfolioReducer';
import promosiReducer from './PromosiReducer';
import propertyDevReducer from './PropertyDevReducer';
import provinsiReducer from './ProvinsiReducer';
import sertifikatReducer from './SertifikatReducer';
import sheReducer from './SHEReducer';
import UserReducer from './UserReducer';

const RootReducer = combineReducers({
  login: LoginReducer,
  user: UserReducer,
  layout: LayoutReducer,
  navigations: NavigationReducer,
  app: appReducer,
  admin: adminReducer,
  provinsi: provinsiReducer,
  kota: kotaReducer,
  manajemenPerusahaan: manajemenPerusahaanReducer,
  sertifikat: sertifikatReducer,
  anakPerusahaan: anakPerusahaanReducer,
  laporanTahunan: laporanTahunanReducer,
  laporanKeuangan: laporanKeuanganReducer,
  media: mediaReducer,
  komiteGCG: KomiteGCGReducer,
  eMagazine: eMagazineReducer,
  csr: csrReducer,
  she: sheReducer,
  hero: heroReducer,
  global: globalReducer,
  milestone: milestoneReducer,
  asetInvest: asetInvestasiReducer,
  karir: karirReducer,
  promosi: promosiReducer,
  gcg: GCGReducer,
  propertyDev: propertyDevReducer,
  hotel: hotelReducer,
  portfolio: portfolioReducer,
  inquiry: inquiryReducer,
  mitra: mitraReducer,
});

export default RootReducer;
